// extracted by mini-css-extract-plugin
export default {"banner":"vlyeDRczGcMO7FzdW6sZ"};